module.exports = __webpack_public_path__ + "media/images/icon-094bf5e09c30e51c2559dc307b40cdf9.svg";